module.exports = __webpack_public_path__ + "img/b3.fb6ecfa.png";